import { useState } from 'react';
import { NoiseMeterOverlay } from './NoiseMeterOverlay.js';
import styles from './NoiseMeterButton.module.css';

/**
 * Bottom-left live-chrome button (sits beside the clock) that opens the
 * full-screen classroom noise meter. Owns the overlay's open state; the overlay
 * handles the mic + Esc-to-close. Rendered inside LiveClock so it only shows
 * while a classroom is live.
 */
export function NoiseMeterButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        className={styles.button}
        onClick={() => setOpen(true)}
        aria-label="Open noise meter"
        title="Noise meter"
        data-testid="noise-meter-button"
      >
        <SoundIcon />
      </button>
      {open ? <NoiseMeterOverlay onClose={() => setOpen(false)} /> : null}
    </>
  );
}

function SoundIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="22"
      height="22"
      aria-hidden="true"
      focusable="false"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Speaker + sound waves — the obvious "sound / volume" glyph. */}
      <path d="M11 5 6 9H2v6h4l5 4V5z" />
      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
      <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
    </svg>
  );
}
